/* eslint func-names: "off" */
import axios from 'axios';

const baseURL = process.env.VUE_APP_ORIGIN || window.location.origin;

const axiosAPI = axios.create({
  baseURL: `${baseURL}/api/content/v2`,
});

const axiosAuthAPI = axios.create({
  baseURL: `${baseURL}/api/auth/v2`,
  withCredentials: true,
});

const axiosAccountAPI = axios.create({
  baseURL: `${baseURL}/api/account/v2`,
  withCredentials: true,
});

const axiosImageAPI = axios.create({
  baseURL: `${baseURL}/api/image/v2`,
});

export {
  axiosAPI,
  axiosAuthAPI,
  axiosAccountAPI,
  axiosImageAPI,
};
// import store from '../store';

// let baseURL = window.location.origin;

// if (process.env.VUE_APP_ORIGIN) {
//   baseURL = process.env.VUE_APP_ORIGIN;
// }

// // Add a response interceptor
// axios.interceptors.response.use((response) => response, async (error) => {
//   if (error.response && error.response.status === 401) {
//     await store.dispatch('destoryCurrentUser');
//     window.location.href = `${baseURL}/auth/login`;
//   }
//   return Promise.reject(error);
// });

// axios.defaults.baseURL = `${baseURL}/api/content/v2`;
// axios.defaults.withCredentials = true;

// export default axios;
